<template>
  <div id="content"
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('dataList')">资料下载</div>
      </div>
    </header>
    <div class="item-class-show">
      <el-row class="item-class-group">
        <el-col class="item-class-name"
                :span="2">
          <span class="book-size">按专业:</span>
        </el-col>
        <el-col class="item-class-name item-class-group"
                :span="22">
          <div v-for="(data,index) in courseList"
               :key="data.id"
               :class="tabIndex===index && !tabSecIndex?'bac':''"
               class="book-item book-size"
               @click="handleSecond(data.id,data.typeName,index)">
            <span>{{data.typeName}}</span>
          </div>
        </el-col>
      </el-row>
      <!-- 二级类目 -->
      <el-row class="item-class-group"
              v-if="secondList.length">
        <el-col class="item-class-name"
                :span="2">
          <span class="book-size"></span>
        </el-col>
        <el-col class="item-class-name item-class-group"
                :span="22">
          <div v-for="(data,index) in secondList"
               :key="data.id"
               class="book-item book-size"
               @click="handleCourse(data.id,index)"
               :class="tabSecIndex===index?'bac':''">
            <span>{{data.typeName}}</span>
          </div>
        </el-col>
      </el-row>
      <!-- 下载排行/最新 -->
      <el-row>
        <el-col :span="24">
          <div class="question-classify">
            <ul>
              <li v-for="(data,index) in datalist2"
                  :class="`${currentIndex===index?'checked':''}`"
                  :key="index"
                  @click="handleIndex(index)">
                {{data}}
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 图书列表 -->
    <div class="train-container meansList">
      <div v-for="(item, index) in dataList"
           :key="item.id"
           class="book"
           :class="index%4==0? 'course-margin' :''">
        <div class="course-img">
          <img :src="item.imgurl?item.imgurl:placeHoderImgUrl"
               :alt="item.docName"
               width="280px"
               height="194px"
               @click="handleDetail(item.id)" />
          <!--  @click="" -->
        </div>
        <div class="course-name">
          <h3 class="overell">{{item.docName}}</h3>
        </div>
        <div class="course-info">
          <div>
            <span>{{item.downloadCount || 0}}人学习</span>
            &nbsp;| &nbsp;
            <span>{{item.viewCount || 0}}浏览</span>
          </div>
          <div class="download">
            <el-progress v-if="item.loading" type="circle" :width="60" :percentage="item.percentage"></el-progress>
            <span class="downLoadButton"
                  @click="handleDownLoad(item.id, item)"
                  v-loading="item.loading">下载</span>
          </div>
        </div>
      </div>
    </div>
    <div class="doclist-pagination"
         v-if="dataList === [] || dataList.length !== 0">
      <div class="doclist-lastpage"
           @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''"
            v-for="(item, index) in pageList"
            :key="index"
            @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage"
           @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{totalPage}}页，到第
        <input type="text"
               v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump"
           @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import { downLoad } from '@/utils'
// import qs from 'qs'
export default {
  data () {
    return {
      userId: null,
      totalPage: 0,
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      courseList: [],
      secondList: [],
      datalist2: ['下载排行', '最新'],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 12,
      totalData: 0,
      dataForm: {
        tag: 1, // 下载排行
        type: null // 图书的类型id 一级或二级类目id
      },
      dataList: [],
      placeHoderImgUrl: '../../../../assets/img/占位图_en.png',
      tabIndex: 0,
      tabSecIndex: '',
      count: 0,
      a: 3
    }
  },
  components: {
    // bookdetail
  },
  mounted () {
    this.getCourse()
    this.getDataList()
    this.getUserId()
  },
  beforeDestroy () {
    window._axiosPromiseArr.forEach(cancel => {
      cancel()
    })
  },
  methods: {
    // 获取userId
    getUserId () {
      this.userId = Cookies.get('userId')
    },
    saveRecord (id) {
      // 埋点
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
        userId: this.userId,
        eventId: 'DATA_DOWNLOAD',
        eventType: 'click',
        desc: '资料下载',
        source: 'PC',
        stayTime: '',
        busId: id
      })
    },
    // 下载
    handleDownLoad (id, item) {
      if (item.loading) return
      if (getAccessToken()) {
        var params = {
          id: id,
          userId: this.userId
        }
        this.$http.get(`/front/train/trainDocumentManagement/download`, {
          params
        }).then(async ({ data: res }) => {
          this.saveRecord(id)
          if (res.code === 0) {
            var path = res.data.url
            // var isPitcure = this.IsPicture(path)
            item.loading = true
            // 大于20MB文件直接下载
            // if (res.data.fileSize > 20 * 1024 * 1024) {
            //   downLoad(path, doSuffix(res.data.fileName, res.data.fileType))
            // } else {
            downLoad(path, res.data.fileName)
            item.percentage = 0
            // }
            item.loading = false
            // if (isPitcure === true) {
            //   this.downloadIamge(res.data.url, res.data.fileName)
            // } else {
            //   window.location.href = res.data.url
            // }
          }
        })
      } else {
        this.$confirm(
          `请登录`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.$router.push({ name: 'login' })
        })
      }
    },
    downloadIamge (imgsrc, name) { // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    downs () {
      this.downloadIamge(this.pic.url, 'pic')
    },
    IsPicture (path) {
      // 判断是否是图片 - strFilter必须是小写列举
      var strFilter = '.jpeg|.gif|.jpg|.png|.bmp|.pic|.svg|'
      if (path.indexOf('.') > -1) {
        var p = path.lastIndexOf('.')
        var strPostfix = path.substring(p, path.length) + '|'
        strPostfix = strPostfix.toLowerCase()
        if (strFilter.indexOf(strPostfix) > -1) {
          return true
        }
      }
      return false
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getDataList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'dataList') {
        this.$router.push({ name: 'dataList' })
      }
    },
    // 下载排行/最新
    handleIndex (index) {
      this.currentPage = 1
      this.currentIndex = index
      this.dataForm.tag = index
      this.getDataList()
    },
    // 获取二级类目
    handleSecond (id, name, index) {
      this.currentPage = 1
      this.tabIndex = index
      this.tabSecIndex = ''
      this.courseList.forEach(data => {
        if (id === data.id) {
          this.secondList = data.child ? data.child : []
          this.dataForm.type = id
          this.getDataList()
          if (!data.child) {
            this.dataForm.type = id
            this.getDataList()
          }
        }
      })
      if (name === '全部') {
        this.dataForm.type = null
        this.getDataList()
      }
    },
    handleCourse (id, index) {
      this.currentPage = 1
      this.tabSecIndex = index
      this.tabIndex = ''
      this.dataForm.type = id
      this.getDataList()
    },
    // 获取列表
    getDataList () {
      this.$http.post(`/front/train/trainDocumentManagement/list`, {
        'page': this.currentPage,
        'limit': this.pageSize,
        'tag': this.dataForm.tag,
        'type': this.dataForm.type
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data.data.map(res => {
            return {
              ...res,
              loading: false,
              percentage: 0
            }
          })
          // 分页
          this.totalPage = Math.ceil(res.data.count / 12)
          // console.log(this.totalPage)
          if (this.totalPage >= 5) {
            this.pageList = [1, 2, 3, 4, 5]
            this.lastOmit = ''
            this.nextOmit = '...'
          } else {
            var newPage = []
            for (let i = 1; i <= this.totalPage; i++) {
              newPage.push(i)
            }
            this.pageList = newPage
            this.lastOmit = ''
            this.nextOmit = ''
          }
        }
      })
    },
    // 获取url
    getUrl (item, id) {
      this.$http.get(`/front/fileupload/alioss/showAliOssSvg/` + id)
        .then(({ data: res }) => {
          if (res.code === 0 && res.svgList[0]) {
            item.url = res.svgList[0]
          }
        })
    },
    // 获取课程分类
    getCourse () {
      this.$http.get(`/front/train/trainCourseType/getTree`)
        .then(({ data: res }) => {
          this.courseList = [{ typeName: '全部' }, ...res.data]
        })
    },
    // 跳转详情
    handleDetail (id) {
      this.$router.push({ name: 'dataDetail', query: { id: id } })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
.item-class-group {
    margin-bottom: 1px;
    margin-top: 1px;
    min-height: 46px;
    line-height: 40px;
    background: #fff;
    // border-bottom: 1px solid #e0dddd;
    // background: url(@/assets/img/fenlex.jpg) no-repeat bottom;
}
.all-book {
  font-weight: normal;
  margin: 20px 0;
  font-size: 26px;
  border-bottom: 1px solid #ccc;
}
.book-size {
  font-size: 14px;
  padding-left: 10px;
}
.book-item {
  float: left;
  // margin: 0 15px 4px 0;
  cursor: pointer;
  padding: 0 10px;
}
.question-classify ul {
  background: #fff;
  width: 100%;
  height: 40px;
}
.question-classify ul li {
  float: left;
  padding: 0 30px;
  color: #333;
  cursor: pointer;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  line-height: 40px;
  height: 40px;
}
.question-classify ul li:first-child {
  border-left: 0;
}
.question-classify ul li.checked {
  background: #1d65a8;
  color: #fff;
}
// 资料列表
.meansList {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.book {
  width: 280px;
  margin-left: 22px;
  margin-bottom: 40px;
  background: #fff;
}
.detail-wrap {
  margin-top: 30px;
}
.book img {
  width: 100%;
  height: 150px;
}
.course-margin {
  margin-left: 0px;
}
.course-img {
  cursor: pointer;
  height: 150px;
}
.course-name {
  margin-top: 10px;
}
.course-name h3 {
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
  padding-left: 5px;
}
.course-info {
  padding-left: 5px;
  line-height: 20px;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  .download {
    position: relative;

    &:hover {
      .el-progress {
        display: block;
      }
    }
  }

  .el-progress {
    position: absolute;
    cursor: pointer;
    display: none;
    border-radius: 50%;
    background: #fff;
    z-index: 2001;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.downLoadButton {
  /* display: inline-block; */
  padding: 1px 12px;
  text-align: center;
  height: 20px;
  font-size: 14px;
  color: #1d65a8;
  cursor: pointer;
}
.bac {
  color: #1d65a8;
}
/* 分页区域样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination {
  display: flex;
  height: 80px;
  padding: 20px 0;
  line-height: 40px;
  text-align: center;
  padding-left: 35px;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
.pageDeavtive {
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
</style>
